export default {
  // Page title
  'page.title': 'स्टॉपवॉच',

  // How to use
  'howto.title': 'उपयोग कैसे करें',
  'howto.step1': 'स्टॉपवॉच शुरू करने के लिए "शुरू करें" बटन पर क्लिक करें, प्रदर्शन प्रारूप: मिनट:सेकंड.सेंटीसेकंड',
  'howto.step2': 'स्टॉपवॉच चल रहा होने पर समय को रोकने के लिए "रोकें" पर क्लिक करें, जारी रखने के लिए फिर से "शुरू करें" पर क्लिक करें',
  'howto.step3': 'स्टॉपवॉच को शून्य पर रीसेट करने और समय को बंद करने के लिए "रीसेट करें" बटन पर क्लिक करें',
  'howto.step4': 'स्टॉपवॉच मिलीसेकंड सटीकता प्रदर्शन का समर्थन करता है, सटीक समय की आवश्यकता वाले परिदृश्यों के लिए उपयुक्त',

  // User reviews
  'reviews.title': 'उपयोगकर्ता समीक्षाएं',
  'reviews.michaelRunner': 'आवश्यक प्रशिक्षण टूल! मिलीसेकंड सटीकता मुझे प्रत्येक स्प्रिंट प्रदर्शन को सटीक रूप से रिकॉर्ड करने की अनुमति देती है, सरल और तेज़ संचालन।',
  'reviews.chefJohnson': 'खाना पकाने का टाइमर जादू! हलचल-तलना, नूडल्स उबालना, अंडे भाप देना सभी को सटीक समय की आवश्यकता होती है, यह स्टॉपवॉच मुझे सही व्यंजन बनाने में मदद करता है।',
  'reviews.sarahStudent': 'परीक्षा सिमुलेशन के लिए आवश्यक! उत्तर देने के समय का अभ्यास करने के लिए उपयोग किया जाता है, साफ इंटरफ़ेस ध्यान विचलित नहीं करेगा, उत्तर देने की दक्षता में सुधार हुआ।',
  'reviews.coachWilliams': 'प्रशिक्षण पाठ्यक्रमों के लिए महान सहायक! अंतराल प्रशिक्षण और प्लैंक को सटीक समय की आवश्यकता होती है, छात्र इसे पसंद करते हैं।',
  'reviews.drAnderson': 'चिकित्सा कार्य को अक्सर सटीक समय की आवश्यकता होती है, यह स्टॉपवॉच सरल और विश्वसनीय है, मेरे नैदानिक कार्य के लिए एक महान सहायक।',

  // User names
  'user.michaelRunner': 'माइकल रनर',
  'user.chefJohnson': 'शेफ जॉनसन',
  'user.sarahStudent': 'सारा स्टूडेंट',
  'user.coachWilliams': 'कोच विलियम्स',
  'user.drAnderson': 'डॉ. एंडरसन',

  // Keywords section
  'keywords.stopwatch': 'stopwatch timer precision timing what time is it now',
  'keywords.chinese': '秒表 计时器 精确计时 现在几点',
  'keywords.japanese': 'ストップウォッチ タイマー 精密計時 今何時',
  'keywords.spanish': 'cronómetro temporizador tiempo preciso qué hora',
  'keywords.german': 'Stoppuhr Timer präzise Zeit wie spät',
  'keywords.french': 'chronomètre minuteur temps précis quelle heure',
  'keywords.russian': 'секундомер таймер точное время который час',
};